// videoLightning({
//   settings: {
//       autoplay: true,
//       color: "white",
//       bdColor: "#000",
//       bdOpacity: "0.5",
//       rickRoll: false,
//       byline:0,
//       portrait: 0,
//       showinfo: 0,
//       zIndex: 99999
//   },
//   elements: [{
//       ".msdw-play-video": {
//           autoplay: true,
//           autoclose: true,
//           ease_out: 1000,
//           width: 1280,
//           height: 720
//       }
//   }]
// });


//
// =VIDEO MODAL
// --------------------------------------------------

const playVideoBtns = document.querySelectorAll(".msdw-play-video");
const msdwPopupVideoWrapper = document.querySelector(
  ".msdw-popup-video-wrapper"
);
const msdwPopupVideoBackDrop = document.querySelector(
  ".msdw-popup-video-backdrop"
);
const msdwPopupVideo = document.getElementById("msdwPopupVideo");

if (document.contains(msdwPopupVideoWrapper)) {
  // open
  playVideoBtns.forEach((playVideoBtn) => {
    playVideoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const videoUrl = playVideoBtn.href;
      msdwPopupVideo.setAttribute("src", videoUrl);
      msdwPopupVideoWrapper.classList.add("msdw-active");
      document.body.classList.add("jws-overflowHidden");
      msdwPopupVideo.muted = false;
      msdwPopupVideo.play();
    });
  });

  // close
  const closePopUpVideo = () => {
    document.body.classList.remove("jws-overflowHidden");
    msdwPopupVideo.muted = true;
    msdwPopupVideo.pause();
    msdwPopupVideo.currentTime = 0;

    msdwPopupVideoWrapper.classList.remove("msdw-active");
  };

  msdwPopupVideoBackDrop.addEventListener("click", () => {
    closePopUpVideo();
  });

  window.onkeydown = (e) => {
    if (e.keyCode == 27) closePopUpVideo();
  };
}



